import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../api/axios';
import toast from 'react-hot-toast';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await API.post('/auth/login', form);
      login(res.data.user, res.data.access_token);
      toast.success(`Welcome back, ${res.data.user.full_name}!`);
      navigate(res.data.user.role === 'admin' ? '/admin' : '/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: 'calc(100vh - 70px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--cream)',
      padding: '2rem'
    }}>
      <div style={{
        background: 'var(--white)',
        borderRadius: '20px',
        padding: '3rem',
        width: '100%',
        maxWidth: '440px',
        boxShadow: 'var(--shadow-lg)'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: '2rem',
            color: 'var(--charcoal)',
            marginBottom: '0.5rem'
          }}>Welcome Back</h1>
          <p style={{ color: 'var(--mid-gray)', fontSize: '0.95rem' }}>
            Sign in to your Kraftova account
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div style={{ marginBottom: '1.2rem' }}>
            <label style={{ display: 'block', marginBottom: '0.4rem', fontWeight: '500', fontSize: '0.9rem' }}>
              Email Address
            </label>
            <input
              type="email"
              placeholder="you@example.com"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              required
              style={{
                width: '100%', padding: '0.75rem 1rem',
                border: '1.5px solid var(--light-gray)',
                borderRadius: '10px', fontSize: '0.95rem',
                outline: 'none', transition: 'var(--transition)',
                background: 'var(--cream)'
              }}
              onFocus={e => e.target.style.borderColor = 'var(--warm-brown)'}
              onBlur={e => e.target.style.borderColor = 'var(--light-gray)'}
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom: '1.8rem' }}>
            <label style={{ display: 'block', marginBottom: '0.4rem', fontWeight: '500', fontSize: '0.9rem' }}>
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              required
              style={{
                width: '100%', padding: '0.75rem 1rem',
                border: '1.5px solid var(--light-gray)',
                borderRadius: '10px', fontSize: '0.95rem',
                outline: 'none', transition: 'var(--transition)',
                background: 'var(--cream)'
              }}
              onFocus={e => e.target.style.borderColor = 'var(--warm-brown)'}
              onBlur={e => e.target.style.borderColor = 'var(--light-gray)'}
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '0.85rem',
              background: loading ? 'var(--mid-gray)' : 'var(--charcoal)',
              color: 'var(--white)', border: 'none',
              borderRadius: '10px', fontSize: '1rem',
              fontWeight: '600', transition: 'var(--transition)',
              letterSpacing: '0.3px'
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        {/* Admin hint */}
        <div style={{
          marginTop: '1.5rem', padding: '0.9rem',
          background: 'var(--light-gray)', borderRadius: '10px',
          fontSize: '0.82rem', color: 'var(--mid-gray)', textAlign: 'center'
        }}>
          <strong>Admin:</strong> admin@threadmarket.com<br />
          <strong>Password:</strong> (set a new admin password — see note below)
        </div>

        <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.9rem', color: 'var(--mid-gray)' }}>
          Don't have an account?{' '}
          <Link to="/register" style={{ color: 'var(--warm-brown)', fontWeight: '600' }}>
            Register here
          </Link>
        </p>
      </div>
    </div>
  );
}